<template>
  <PrintPage :pageNumber="pageNumber" :pageCount="pageCount">
    <template v-slot:header>
      <slot>
        <div class="header-grid"></div>
      </slot>
    </template>

    <div class="content-box">
      <div class="content-box-header">
        <h3>{{ $t('installationTeamDocumentation') }} - X. {{ $t('storage') }}</h3>
      </div>

      <div class="two-column-grid">
        <div>{{ $t('storageAttachment_F') }}</div>
        <div>
          <img
            v-if="project.enpalReport.storageAttachment_F"
            :src="project.enpalReport.storageAttachment_F.path"
          />
        </div>
      </div>

      <div class="two-column-grid">
        <div>{{ $t('storageGState') }}</div>
        <div>
          {{ $t(project.enpalReport.storageGState) }}
        </div>
      </div>

      <div class="two-column-grid">
        <div>{{ $t('storageAttachment_H') }}</div>
        <div>
          <img
            v-if="project.enpalReport.storageAttachment_H"
            :src="project.enpalReport.storageAttachment_H.path"
          />
        </div>
      </div>
    </div>
  </PrintPage>
</template>

<script>
import PrintPage from '@/components/Print/PrintPage';

export default {
  components: {
    PrintPage,
  },
  props: {
    project: null,
    pageCount: { type: Number, default: 1 },
    pageNumber: { type: Number, default: 0 },
  },
  methods: {
    range(min, max) {
      const array = [];
      let j = 0;
      for (var i = min; i <= max; i++) {
        array[j] = i;
        j++;
      }
      return array;
    },
  },
};
</script>

<style src="./ReportPrintPage.scss" lang="scss" />
